import { render, staticRenderFns } from "./pufaLipCheck.vue?vue&type=template&id=4d4170fd&scoped=true"
import script from "./pufaLipCheck.vue?vue&type=script&lang=js"
export * from "./pufaLipCheck.vue?vue&type=script&lang=js"
import style0 from "./pufaLipCheck.vue?vue&type=style&index=0&id=4d4170fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4170fd",
  null
  
)

export default component.exports